<template>
    <out-put-page title="ETUDE FINANCIÈRE" v-if="show">
        <section>
            <h3>
                Chiffre d’affaires prévisionnel (HT)
            </h3>
            <VueApexCharts
                width="1000px"
                type="area"
                :options="chartOptionsChiffreDaffaire"
                :series="ChiffreDaffaireSeries"
                class="flex justify-center"
            />
        </section>
        <section>
            <h3>Achats prévisionnels (HT)</h3>
            <VueApexCharts
                class="flex justify-center"
                width="1000px"
                type="area"
                :options="chartOptionsAchatPrev"
                :series="AchatPrevSeries"
            />
        </section>
    </out-put-page>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import OutPutPage from "../components/OutPutPage";
import { formatPrice } from "@/utils.js";

export default {
    components: {
        OutPutPage,
        VueApexCharts
    },
    props: {
        cpc: {
            required: true
        },
        currentYear: {
            required: true
        }
    },

    mounted() {
        this.cpc.forEach((elem, index) => {
            this.chartOptionsAchatPrev.labels.push(
                `${this.currentYear + index}`
            );
            this.chartOptionsChiffreDaffaire.labels.push(
                `${this.currentYear + index}`
            );
            this.ChiffreDaffaireSeries[0].data.push(elem.chifreAffaire);
            this.AchatPrevSeries[0].data.push(elem.achatsPrevisionnel);
        });
        this.$nextTick(() => {
            this.show = true;
        });
    },
    data() {
        return {
            show: false,
            ChiffreDaffaireSeries: [
                {
                    name: "Chiffre d'affaires (DH)",
                    data: []
                }
            ],
            chartOptionsChiffreDaffaire: {
                dataLabels: {
                    enabled: true,
                    formatter: val => {
                        return formatPrice(val);
                    }
                },
                grid: { padding: { right: 50, left: 0 } },
                chart: {
                    toolbar: {
                        show: false
                    },
                    type: "area",
                    stacked: false
                },
                stroke: {
                    width: [1],
                    curve: "straight"
                },

                plotOptions: {},

                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: "light",
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: [],
                markers: {
                    size: 0
                },
                xaxis: {
                    type: "datetime"
                },
                yaxis: {
                    title: {
                        text: "Chiffre d'affaires prévisionnel (DH) "
                    },
                    tickAmount: 10,
                    min: 0,

                    labels: {
                        formatter: value => {
                            return formatPrice(value);
                        }
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function(y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(2) + " dh";
                            }
                            return y;
                        }
                    }
                }
            },
            AchatPrevSeries: [
                {
                    name: "Achats prévisionnels (DH) ",
                    data: []
                }
            ],
            chartOptionsAchatPrev: {
                dataLabels: {
                    enabled: true,
                    formatter: val => {
                        return formatPrice(val);
                    }
                },
                grid: {
                    padding: {
                        right: 50
                    }
                },
                chart: {
                    toolbar: {
                        show: false
                    },
                    type: "area",
                    stacked: false
                },
                stroke: {
                    width: [1],
                    curve: "straight"
                },
                plotOptions: {},

                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: "light",
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: [],
                markers: {
                    size: 0
                },
                xaxis: {
                    type: "datetime",
                    tickAmount: 10
                },
                yaxis: {
                    title: {
                        text: "Achats prévisionnel (DH) "
                    },
                    min: 0,
                    labels: {
                        formatter: value => {
                            return formatPrice(value);
                        }
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function(y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(2) + " points";
                            }
                            return y;
                        }
                    }
                }
            }
        };
    }
};
</script>
